import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { OutBoxMessagesService } from 'src/app/core/api/services';
import { DynamicTabService } from 'src/app/core/services/dynamic-tab.service';
import { TransferDataService } from 'src/app/core/services/transfer-data.service';
import {
  CustomResultOfPaginatedListOfGetInformationWithPaginationDto,
  GetInformationWithPaginationDto,
  PaginatedListOfGetInformationWithPaginationDto,
} from '../../../core/api/models';
import { InformationsService } from '../../../core/api/services/informations.service';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { FormPageConfig } from './../../../core/models/form-page-config.model';
import { PageNames } from 'src/app/configs/page-names.enum';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { InformationsFormComponent } from './informations-form/informations-form.component';



@Component({
    selector: 'app-informations',
    imports: [BaseIndexModule, InformationsFormComponent],
    templateUrl: './informations.component.html'
})
export class InformationsComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = PageNames.informations;
  modelWithPagination$: Observable<PaginatedListOfGetInformationWithPaginationDto>;
  items$: Observable<Array<GetInformationWithPaginationDto>>;
  formPageConfig: FormPageConfig<any> = {};

  /* Binding service endpoints */
  protected currentService = inject(InformationsService);
  paginationApiMethodName: string = this.currentService.informationsGetInformationsWithPagination.name;
  createGetApiMethodName: string = this.currentService.informationsCreateGet.name;
  auditApiMethodName: string = this.currentService.informationsGetInformationsAuditWithPagination.name;
  deleteApiMethodName: string = this.currentService.informationsDelete.name;
  //#endregion

  constructor(
    public outBoxMessagesService: OutBoxMessagesService,
    public dynamicTabService: DynamicTabService
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: this.localizer.title,
        name: 'title',
        hasSearch: true,
      },
      // {
      //   title: this.localizer.text,
      //   name: 'contentText',
      //   noSorting: false,
      //   hasSearch: true,
      // },
      {
        title: `${this.tableVocabs}customerDomainName`,
        name: 'customerDomainName',
        hasSearch: true,
      },
      {
        title: this.localizer.active,
        name: 'isActive',
        type: 'boolean',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}isRequiredToSeen`,
        name: 'isRequiredToSeen',
        type: 'boolean',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}displayForAllSubOrganizations`,
        name: 'displayForAllSubOrganizations',
        type: 'boolean',
        hasSearch: true,
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
      {
        title: this.localizer.startDate,
        name: 'startDate',
        hasSearch: true,
        type: 'date',
      },
      {
        title: this.localizer.endDate,
        name: 'endDate',
        hasSearch: true,
        type: 'date',
      },
    ];
  }

  //#region Api

  //Get ById
  baseGetByIdApi(id: number): void {
    // if (!this.isSuperAdmin && !this.isOrganizationAdmin) return;

    this.unSubs();

    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .informationsUpdateGet({ id: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserver);
  }

  //#endregion

  onShowInformationUsersSeen(tabName, id) {
    TransferDataService.id = id;
    this.dynamicTabService.setNewTab('');
    this.dynamicTabService.setNewTab(tabName);
    this.dynamicTabService.setActiveTab(tabName);
  }
}
